export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-500592b3864077af5b9fa3366cec91df.svg";